export const getUsuarios = (state) => {
  return state.usuarioslista;
};

export const getUsuariosInfo = (state) => {
  return state.usuariosinfo;
};
